import { createStyles, Theme } from '@material-ui/core'

export const searchFilterCardStyle = (theme: Theme) =>
  createStyles({
    card: {
      marginBottom: theme.spacing(2),
      '& .MuiToolbar-root': {
        marginTop: '0px !important',
        marginBottom: '0px !important',
        minHeight: '0px'
      },
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        minHeight: '0px',
        marginTop: '0px !important',
        marginBottom: '0px !important'
      },
      '& .makeStyles-mainSectionHeader': {
        marginTop: '0 !important',
        marginBottom: '0 !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
      },
      '& [class*="makeStyles-mainSectionHeader"]': {
        marginTop: '0 !important',
        marginBottom: '0 !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
      },
      '& .makeStyles-mainSectionTitle': {
        margin: '0 !important'
      },
      '& [class*="makeStyles-mainSectionTitle"]': {
        margin: '0 !important'
      }
    },
    chipContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      padding: theme.spacing(2),
      paddingBottom: 0,
      flexWrap: 'wrap'
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      gap: theme.spacing(1),
      margin: theme.spacing(1)
    }
  })
